import { Controller } from '@hotwired/stimulus';
import up from '@/lib/unpoly';

export default class extends Controller {
  static targets = ['all', 'item'];

  uncheckItem(event) {
    if (event.target.checked) {
      this.itemTargets.forEach((item) => {
        const checkbox = item;
        checkbox.checked = false;
      });
      up.submit(event.target.form);
    }
  }

  uncheckAll(event) {
    if (event.target.checked) {
      this.allTarget.checked = false;
    }
  }
}
